// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
/* rtl:begin:ignore */
.skeletons-module__gradient___eW5qf {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: skeletons-module__placeHolderShimmer___didpS;
  animation-timing-function: linear;
  background: var(--base, #f4f4f7);
  background: linear-gradient(135deg, var(--base, #f4f4f7) 8%, var(--surface2, #fafafa) 38%, var(--base, #f4f4f7) 54%);
  background-size: 1000px 640px;
  position: relative;
}

@keyframes skeletons-module__placeHolderShimmer___didpS {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
/* rtl:end:ignore */`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/skeletons/skeletons.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA,qBAAA;AACA;EACE,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,4DAAA;EACA,iCAAA;EACA,gCAAA;EACA,oHAAA;EAMA,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,6BAAA;EACF;EACA;IACE,4BAAA;EACF;AACF;AACA,mBAAA","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../styles/utils';\n\n/* rtl:begin:ignore */\n.gradient {\n  animation-duration: 1.8s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeHolderShimmer;\n  animation-timing-function: linear;\n  background: color(base);\n  background: linear-gradient(\n    135deg,\n    color(base) 8%,\n    color(surface2) 38%,\n    color(base) 54%\n  );\n  background-size: 1000px 640px;\n  position: relative;\n}\n\n@keyframes placeHolderShimmer {\n  0% {\n    background-position: -468px 0;\n  }\n  100% {\n    background-position: 468px 0;\n  }\n}\n/* rtl:end:ignore */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gradient": `skeletons-module__gradient___eW5qf`,
	"placeHolderShimmer": `skeletons-module__placeHolderShimmer___didpS`
};
export default ___CSS_LOADER_EXPORT___;
